import { useState, useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { genericGETDatabaseCall, genericDELETEDatabaseCall } from '../helperFunctions.jsx';
import { message } from 'antd';
import { ExportOutlined, DeleteFilled } from '@ant-design/icons'

async function getAllDashboardEntitiesFromServer() {
  return genericGETDatabaseCall('/api/psbb/getDashboardEntities', 'all dashboard entities');
}

async function deleteDashboardEntityFromServer(entityId) {
  return genericDELETEDatabaseCall('/api/psbb/deleteDashboardEntity', { entityId }, 'dashboard entity');
}

export function Dashboard() {
  const [allEntities, setAllEntities] = useState([]);
  const [messageApi, contextHolder] = message.useMessage();
  const navigate = useNavigate();


  const getAllDashboardEntities = useCallback(async () => {
    messageApi.loading("Loading all Dashboard entities...");
    try {
      const data = await getAllDashboardEntitiesFromServer();
      messageApi.destroy();
      messageApi.success("All Dashboard entities loaded successfully");
      setAllEntities(data);
    } catch (error) {
      messageApi.destroy();
      messageApi.error("Failed to load all dashboard entities");
      console.error(error);
    }
  }, [messageApi]);

  const deleteDashboardEntity = async (entityId) => {
    messageApi.loading("Deleting Dashboard entity..");
    try {
      await deleteDashboardEntityFromServer(entityId);
      messageApi.destroy();
      messageApi.success("Dashboard entity deleted successfully");
      setAllEntities(allEntities.filter((entity) => entity.shared_link_uuid != entityId));
    } catch (error) {
      messageApi.destroy();
      messageApi.error("Failed to delete dashboard entity");
      console.error(error);
    }
  };

  useEffect(() => {
    getAllDashboardEntities();
  }, [getAllDashboardEntities]);

  return (
    <>
      {contextHolder}
      <div className="entity-industry-container">
        <div>
          <h2>Dashboard</h2>
        </div>
        {allEntities.map((entity) => (
          <div key={entity.shared_link_uuid} className="flex-row" style={{ backgroundColor: '#182a44', borderRadius: '16px', padding: '16px', justifyContent: 'space-between', marginBottom: '20px' }}>
            <div>
              <div>Name: {entity.name}</div>
              <div>Underlying Entity Name: {entity.entity_name}</div>
              <div>Created At: {new Date(entity.created_at).toDateString()}</div>
            </div>
            <div>
              <button onClick={() => deleteDashboardEntity(entity.shared_link_uuid)} style={{ backgroundColor: '#d20e39', borderRadius: '8px', padding: '8px 16px', color: 'white', border: 'none', cursor: 'pointer', marginRight: '12px' }}>
                <span>Delete</span><DeleteFilled />
              </button>
              <button onClick={() => { navigate('/renderTemplate?templateId=' + entity.shared_link_uuid) }} style={{ backgroundColor: '#007233', borderRadius: '8px', padding: '8px 16px', color: 'white', border: 'none', cursor: 'pointer' }}>
                <span>Open </span><ExportOutlined />
              </button>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}


export default Dashboard;